<template lang="pug">
div
  button.btn.btn-primary(
    type="button"
    @click="showModal"
  ) {{ t('my_subscription.modal.show') }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'subscriptions-contract-button-vue',
  mixins: [ mixins.translate ],
  props: {
    service: { type: String, require: true }
  },
  methods: {
    showModal() {
      this.$root.$emit('open-contract-form-modal', this.service)
    }
  }
}
</script>
